import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Panel, PanelHeader, PanelContent } from "../../shared/create-offer/Panel";
import TimelineSteps from "../../shared/create-offer/TimelineSteps/TimelineSteps";
import FidelityProgram from "../components/new-offer/step1-fidelityProgram";
import { useNewOffer } from "../context/new-offer";
import {
	ROUTE_HOME,
	ROUTE_PREFIX_EDIT_OFFER,
	ROUTE_PREFIX_CREATE_OFFER
} from "../shared/constants";
import {
	VinduloPendenteModal,
	VendaRapidaNaoElegivel,
	AvisoProblemaModal,
	AvisoProblemaModalPagamentoAntecipado,
	EditarNaoElegivel,
	EditarPerderBonus,
	EditarNaoElegivelPagamentoAntecipado
} from "../services/modals";
import { receivePhoneRequiredMode } from "../actions";

const initialSteps = [
	{
		label: "Programa de fidelidade"
	},
	{
		label: "Oferta de milhas"
	},
	{
		label: "Dados de cadastro"
	}
];

const NewOffer = props => {
	const {
		programsFidelity,
		fetchBanksData,
		fetchDataUser,
		newOfferTempData,
		offerData,
		rankingData,
		setCurrentProgram,
		setOfferData,
		setRankingData,
		setNewOfferTempData,
		setSmilesDiamond,
		offersData,
		selectOfferToEdit,
		editOffer,
		quickSaleProblem,
		setQuickSaleProblem,
		cleanNewOfferTempData,
		participantData,
		fetchOffersData
	} = useNewOffer();

	const [filteredCompanies, handleFilteredCompanies] = useState([]);

	const phoneRequiredMode = () => {
		for (let i = 0; i < programsFidelity?.data?.length; i += 1) {
			if (
				programsFidelity?.data[i]?.acronym === "Latam" &&
				programsFidelity?.data[i]?.international === "0"
			) {
				return programsFidelity?.data[i]?.phoneRequiredMode;
			}
		}
	};
	const { receivePhoneRequiredMode } = props;
	const typePhoneLatam = phoneRequiredMode();
	receivePhoneRequiredMode(typePhoneLatam);
	const [modals, setModals] = useState({
		ofertaEmVenda: false,
		ofertaNaoAprovada: false,
		editarOferta: false,
		vinculoPendente: false,
		avisoProblemaModal: false,
		avisoProblemaModalPagamentoAntecipado: false,
		avisoNaoElegivelModal: false,
		avisoNaoElegivelModalPagamentoAntecipado: false
	});
	const [stepsData] = useState(initialSteps);
	const [programToEdit, setProgramToEdit] = useState(undefined);

	// atualiza offers do context
	useEffect(() => {
		fetchOffersData();
	}, []);

	useEffect(() => {
		if (programsFidelity.data.length > 0) {
			handleFilteredCompanies(programsFidelity.data);
		}
	}, [programsFidelity.data]);

	useEffect(() => {
		setModals({
			...modals,
			vendaRapidaNaoElegivel: quickSaleProblem,
			vinculoPendente: participantData.isDone && participantData.hasRelationshipPendent
		});
	}, [quickSaleProblem, participantData]);

	const cleanDataContext = () => {
		// Clean all data if it's a new offer
		cleanNewOfferTempData();
		selectOfferToEdit({});
		setRankingData({ ...rankingData, data: {} });
		setOfferData({
			...offerData,
			data: {
				price: 0,
				quant: 0,
				averageMiles: 0,
				reductions: 0
			}
		});
		setSmilesDiamond(undefined);
	};

	// Seleciona o programa de fidelidade e poem no stado para
	// passar para o componente de Dados de Registro
	const selectFidelityProgram = async (obj, ignoreModal) => {
		// Limpa store
		cleanDataContext();

		// Procura se ja existe oferta, se existir ele entra no fluxo edição
		if (offersData.data.offers && offersData.data.offers.length) {
			let offerFound = offersData.data.offers.find(
				offer => offer.fidelity.id === obj.id && offer.status > 0
			);
			if (
				offerFound &&
				offerFound.editable === false &&
				offerFound.type == 4 &&
				offerFound.status !== 4
			) {
				setModals({ ...modals, avisoProblemaModalPagamentoAntecipado: true });
				return;
			} else if (offerFound && offerFound.editable === false) {
				setModals({ ...modals, avisoProblemaModal: true });
				return;
			} else if (offerFound && (offerFound.type == 2 || !!offerFound.hasBonus) && !ignoreModal) {
				setProgramToEdit(obj);
				setModals({
					...modals,
					avisoNaoElegivelModal: offerFound.type == 2,
					avisoPerderBonusModal: !!offerFound.hasBonus
				});
				return;
			} else if (offerFound && (offerFound.type == 4 || !!offerFound.hasBonus) && !ignoreModal) {
				setProgramToEdit(obj);
				setModals({
					...modals,
					avisoNaoElegivelModalPagamentoAntecipado: offerFound.type == 4,
					avisoPerderBonusModal: !!offerFound.hasBonus
				});
				return;
			} else if (offerFound) {
				selectOfferToEdit(offerFound);
				props.history.push(ROUTE_PREFIX_EDIT_OFFER);
				return;
			}
		}
		setNewOfferTempData({ ...newOfferTempData, loyaltyData: obj });
		fetchDataUser(obj.id);
		fetchBanksData();
		setCurrentProgram(obj);
		props.history.push(ROUTE_PREFIX_CREATE_OFFER);
	};

	const confirmEdit = () => {
		setModals({
			...modals,
			avisoNaoElegivelModal: false,
			avisoNaoElegivelModalPagamentoAntecipado: false,
			avisoPerderBonusModal: false
		});
		selectFidelityProgram(programToEdit, true);
		setProgramToEdit(undefined);
	};

	const filterCompanies = val => {
		if (val.length > 0) {
			let companies = programsFidelity.data.filter(v => {
				return (
					v.acronym.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
					v.fidelityName.toLowerCase().indexOf(val.toLowerCase()) > -1
				);
			});

			handleFilteredCompanies(companies);
		} else {
			handleFilteredCompanies(programsFidelity.data);
		}
	};

	return (
		<div className="new-offers">
			<Panel>
				<PanelHeader className="flex-column">
					<TimelineSteps data={stepsData} step={1} approvedSteps={0} />
				</PanelHeader>
				<PanelContent>
					<FidelityProgram
						loading={programsFidelity.isFetching}
						companies={filteredCompanies}
						onChange={obj => selectFidelityProgram(obj)}
						filterCompanies={filterCompanies}
						typePhoneLatam={typePhoneLatam}
					/>
				</PanelContent>
			</Panel>
			<VendaRapidaNaoElegivel
				show={modals.vendaRapidaNaoElegivel}
				onConfirm={() => {
					setQuickSaleProblem(false);
					editOffer.quickSale = undefined;
					setModals({ ...modals, vendaRapidaNaoElegivel: false });
				}}
			/>
			<VinduloPendenteModal
				show={modals.vinculoPendente}
				onConfirm={() => {
					setModals({ ...modals, vinculoPendente: false });
					props.history.push(ROUTE_HOME);
				}}
			/>
			<AvisoProblemaModal
				show={modals.avisoProblemaModal}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModal: false });
					props.history.push(ROUTE_HOME);
				}}
			/>
			<AvisoProblemaModalPagamentoAntecipado
				show={modals.avisoProblemaModalPagamentoAntecipado}
				onConfirm={() => {
					setModals({ ...modals, avisoProblemaModalPagamentoAntecipado: false });
					props.history.push(ROUTE_HOME);
				}}
			/>
			<EditarNaoElegivel
				show={modals.avisoNaoElegivelModal}
				onCancel={() => setModals({ ...modals, avisoNaoElegivelModal: false })}
				onConfirm={confirmEdit}
			/>
			<EditarNaoElegivelPagamentoAntecipado
				show={modals.avisoNaoElegivelModalPagamentoAntecipado}
				onCancel={() => setModals({ ...modals, avisoNaoElegivelModalPagamentoAntecipado: false })}
				onConfirm={confirmEdit}
			/>
			<EditarPerderBonus
				show={modals.avisoPerderBonusModal}
				onCancel={() => setModals({ ...modals, avisoPerderBonusModal: false })}
				onConfirm={confirmEdit}
			/>
		</div>
	);
};

const mapStateToProps = state => {
	return {
		typePhoneLatam: state.createOffer.typePhoneLatam
	};
};

const mapDispatchToProps = dispatch => {
	return {
		receivePhoneRequiredMode: typePhoneLatam => dispatch(receivePhoneRequiredMode(typePhoneLatam))
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewOffer));
